import { render, staticRenderFns } from "./CsvImportWizard.vue?vue&type=template&id=21820063"
import script from "./CsvImportWizard.vue?vue&type=script&lang=ts"
export * from "./CsvImportWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports